import { CloseIcon, HamburgerIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Flex,
  Icon,
  IconButton,
  Link,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Stack,
  Text,
  Tooltip,
  useColorModeValue,
  useDisclosure,
} from "@chakra-ui/react";
import { Network } from "@models/network";
import { logOut, useUserStore } from "@providers/auth";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { RiLogoutBoxRLine } from "react-icons/ri";
import Logo from "../../public/images/logo.svg";

export default function WithSubnavigation() {
  const user = useUserStore((state) => state.user);
  const { isOpen, onToggle } = useDisclosure();

  const copyWallet = () => {
    navigator.clipboard.writeText(
      user?.getWalletsByNetwork(Network.POLYGON)[0].address || ""
    );
  };

  const mobileNavCollapseDisplay = isOpen ? "max-h-[500px]" : "max-h-0";

  return (
    <Box borderBottom="2px solid #010613">
      <Flex
        shadow="base"
        //bg={'neutral.850'}
        bg="background"
        justify={"space-between"}
        align={"center"}
        color={useColorModeValue("gray.600", "white")}
        minH={"110px"}
        py={{ base: 4 }}
        px={{ base: 8, md: 16 }}
        //borderBottom={1}
        borderStyle={"solid"}
        borderColor={useColorModeValue("gray.200", "gray.900")}
        flexWrap="nowrap"
      >
        <Link href="/">
          <div className="w-48 sm:w-64 cursor-pointer svg-black ">
            <Image src={Logo} alt="moongate" />
          </div>
        </Link>

        <Flex display={{ base: "none", md: "flex" }} padding="1rem">
          <DesktopNav />
        </Flex>

        <Flex
          display={{ base: "none", md: "flex" }}
          flex={0}
          justify={"flex-end"}
          direction={"row"}
          alignItems="center"
          minW="auto"
        >
          {user ? (
            <>
              <div className="flex flex-col mr-1 justify-center items-center text-xs">
                {user.email && <p className="mb-1">{user.email}</p>}

                <Tooltip
                  label={user.getWalletsByNetwork(Network.POLYGON)[0].address}
                >
                  <p
                    className="bg-neutral-800 py-1 px-4 rounded-full cursor-pointer text-xs"
                    onClick={copyWallet}
                  >
                    {
                      user.getWalletsByNetwork(Network.POLYGON)[0]
                        .addressPreview
                    }
                  </p>
                </Tooltip>
              </div>
              <IconButton
                onClick={() => logOut()}
                aria-label="log out"
                variant="ghost"
                icon={
                  <Icon as={RiLogoutBoxRLine} w={5} h={5} color="white"></Icon>
                }
              ></IconButton>
            </>
          ) : (
            <></>
          )}

          <Button
            variant="gradient"
            py={3}
            marginLeft={4}
            onClick={() =>
              window.open(
                "https://app.moongate.id",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            <p>Launch App</p>
          </Button>
        </Flex>

        <Flex
          flex={{ base: 1, md: 0 }}
          display={{ base: "flex", md: "none" }}
          justify={"flex-end"}
        >
          <IconButton
            onClick={onToggle}
            icon={
              isOpen ? (
                <CloseIcon w={3} h={3} color="white" />
              ) : (
                <HamburgerIcon w={5} h={5} color="white" />
              )
            }
            variant={"ghost"}
            aria-label={"Toggle Navigation"}
          />
        </Flex>
      </Flex>

      {/* <Collapse in={isOpen} > */}
      <div
        //className={`${mobileNavCollapseDisplay} overflow-hidden transition-[max-height] duration-500 ease-out`}
        className={`${mobileNavCollapseDisplay} overflow-hidden `}
      >
        <MobileNav />
      </div>
      {/* </Collapse> */}
    </Box>
  );
}

const DesktopNav = () => {
  const linkColor = useColorModeValue("gray.600", "gray.200");
  const linkHoverColor = useColorModeValue("gray.800", "white");
  const popoverContentBgColor = useColorModeValue("white", "gray.800");
  const t = useTranslations("index");
  const navItems: Array<NavItem> = [
    // {
    //   label: t("TBW"),
    //   href: "https://www.taipeiblockchainweek.com/",
    // },
    // Side Events
    // {
    //   label: t("sideEvents"),
    //   href: "https://app.moongate.id/discover?tags=TBW2022",
    //   target: "_blank",
    // },
    // {
    //   label: `${t("about")} ${t("aboutMoongate")}`,
    //   href: "https://moongate.id/",
    // },
    //{
    //  label: t("forProjects"),
    //  href: "https://moongate.id/projects",
    //},
    //{
    //  label: t("forUsers"),
    //  href: "https://moongate.id/users",
    //},
    //{
    //  label: t("whitepaper"),
    //  href: "https://moongate.gitbook.io/moongate-whitepaper/",
    //},
    // {
    //   label: t("liveEvents"),
    //   href: "#",
    // },
  ];

  return (
    <Stack direction={"row"} spacing={4} alignItems="center">
      {navItems.map((navItem) => (
        <Box key={navItem.label}>
          <Popover trigger={"hover"} placement={"bottom-start"}>
            <PopoverTrigger>
              <Link
                p={2}
                href={navItem.href ?? "#"}
                target={navItem.target ?? "_self"}
                fontSize={"0.9rem"}
                fontWeight={500}
                color={linkColor}
                _hover={{
                  textDecoration: "none",
                  color: linkHoverColor,
                }}
              >
                {navItem.label}
              </Link>
            </PopoverTrigger>

            {navItem.children && (
              <PopoverContent
                border={0}
                boxShadow={"xl"}
                bg={popoverContentBgColor}
                p={4}
                rounded={"xl"}
                minW={"sm"}
              >
                <Stack>
                  {navItem.children.map((child) => (
                    <DesktopSubNav key={child.label} {...child} />
                  ))}
                </Stack>
              </PopoverContent>
            )}
          </Popover>
        </Box>
      ))}
    </Stack>
  );
};

const DesktopSubNav = ({ label, href, subLabel, target }: NavItem) => {
  return (
    <Link
      href={href}
      target={target ?? "_self"}
      role={"group"}
      display={"block"}
      p={2}
      rounded={"md"}
      _hover={{ bg: useColorModeValue("pink.50", "gray.900") }}
    >
      <Stack direction={"row"} align={"center"}>
        <Box>
          <Text
            transition={"all .3s ease"}
            _groupHover={{ color: "pink.400" }}
            fontWeight={500}
          >
            {label}
          </Text>
          <Text fontSize={"sm"}>{subLabel}</Text>
        </Box>
        <Flex
          transition={"all .3s ease"}
          transform={"translateX(-10px)"}
          opacity={0}
          _groupHover={{ opacity: "100%", transform: "translateX(0)" }}
          justify={"flex-end"}
          align={"center"}
          flex={1}
        >
          <Icon
            color={"pink.400"}
            w={5}
            h={5}
            //as={ChevronRightIcon}
          />
        </Flex>
      </Stack>
    </Link>
  );
};

const MobileNav = () => {
  const t = useTranslations("index");
  const user = useUserStore((state) => state.user);

  const navItems: Array<NavItem> = [
    // {
    //   label: t("TBW"),
    //   href: "https://www.taipeiblockchainweek.com/",
    // },
    // Side Events
    // {
    //   label: t("sideEvents"),
    //   href: "https://app.moongate.id/discover?tags=TBW2022",
    //   target: "_blank",
    // },
    // {
    //   label: `${t("about")} ${t("aboutMoongate")}`,
    //   href: "https://moongate.id/",
    // },
    // {
    //   label: t("forProjects"),
    //   href: "https://moongate.id/projects",
    // },
    // {
    //   label: t("forUsers"),
    //   href: "https://moongate.id/users",
    // },
    // {
    //   label: t("whitepaper"),
    //   href: "https://moongate.gitbook.io/moongate-whitepaper/",
    // },
    // {
    //   label: t("liveEvents"),
    //   href: "#",
    // },
  ];

  return (
    <Stack
      //bg={useColorModeValue("white", "gray.800")}
      bg="background"
      display={{ md: "none" }}
      spacing={4}
    >
      {navItems.map((navItem) => (
        <MobileNavItem key={navItem.label} {...navItem} />
      ))}

      <div className="w-full flex justify-center pb-4 ">
        <Button
          variant="gradient"
          className="flex flex-row justify-center items-center self-center font-semibold"
          onClick={() =>
            window.open(
              "https://app.moongate.id",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          Launch App
        </Button>
      </div>
      {user && (
        <div className="pb-4">
          <a
            className="flex flex-row justify-center items-center font-semibold"
            onClick={() => logOut()}
          >
            {t("logout")}
          </a>
        </div>
      )}
    </Stack>
  );
};

const MobileNavItem = ({ label, children, href, target }: NavItem) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Stack spacing={4} onClick={children && onToggle}>
      <Flex
        py={2}
        as={Link}
        href={href ?? "#"}
        target={target ?? "_self"}
        justify={"center"}
        align={"center"}
        _hover={{
          textDecoration: "none",
        }}
      >
        <Text
          fontWeight={600}
          color={useColorModeValue("gray.600", "gray.200")}
        >
          {label}
        </Text>
        {children && (
          <Icon
            //as={ChevronDownIcon}
            transition={"all .25s ease-in-out"}
            transform={isOpen ? "rotate(180deg)" : ""}
            w={6}
            h={6}
          />
        )}
      </Flex>

      <Collapse in={isOpen} animateOpacity style={{ marginTop: "0!important" }}>
        <Stack
          mt={2}
          pl={4}
          borderLeft={1}
          borderStyle={"solid"}
          borderColor={useColorModeValue("gray.200", "gray.700")}
          align={"center"}
          justify={"center"}
        >
          {children &&
            children.map((child) => (
              <a
                key={child.href}
                href={child.href}
                target="_blank"
                rel="noreferrer"
              >
                {child.label}
              </a>
            ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};

interface NavItem {
  label: string;
  subLabel?: string;
  children?: Array<NavItem>;
  href?: string;
  target?: string;
}
